
const config = window.config;

const aggr_keys = ['project', 'subproject', 'POSTEMBARGO', 'erns', 'library_contruction_protocol', 'kit', 'tissue', "Owner", "library_strategy", "file_submission_close", "in_platform", "processed"];

const exp_search_delayed = ['ExperimentID', 'LocalExperimentID', 'Participant_ID', 'cnag_barcode', 'subproject'];

const header_exp_config = [
    { label: 'Owner', key: 'Owner', width: 160},
    { label:  config.platform_label + ' ID', key: 'ExperimentID', tooltip: "Unique " + config.platform_label + " Experiment Identifier.", width: 130},
    { label: 'Local Experiment ID', key: 'LocalExperimentID', width: 190},
    { label: 'Participant ID', key: 'Participant_ID', width: 120},
    { label: 'Projects', key: 'project', width: 250},
    { label: 'Subproject', key: 'subproject', width: 150},
    { label: 'CNAG Barcode', key: 'cnag_barcode', tooltip: "Lims barcode associated to the experiment for samples sequenced at the CNAG", width: 150},
    { label: 'Protocol/Kit', key: 'kit', width: 300},
    { label: 'Tissue', key: 'tissue', width: 200},
    { label: 'Library Strategy', key: 'library_strategy', width: 120},
    { label: 'Library Construction Protocol', key: 'library_contruction_protocol', width: 150},
    { label: 'File Submission', key: 'file_submission_close', tooltip:"Experiment owner has declared that no more files will be submitted.", width: 150},
    { label: 'Postembargo', key: 'POSTEMBARGO', width: 150},
    { label: 'Processed', key: 'processed', tooltip: "Variant calling already generated.", width: 150},
    { label: 'In Platform', key: 'in_platform', tooltip: "Experiment fully processed and uploaded to GPAP Platform for analysis.", width: 120},
    { label: 'LoadDate', key: 'LOADDATE', width: 150},
    { label: 'ERNs', key: 'erns', width: 200},
    { label: 'SharedGroups', key: 'SharedGroups', width: 250},
    { label: 'EGA ID', key: 'EGA_ID', width: 150},
    { label: 'BioBank Name', key: 'BioBank', width: 250},
    { label: 'BioBankSample ID', key: 'Sample_ID', width: 150}
];

const files_search_delayed = ['ExperimentID', 'LocalExperimentID', 'Participant_ID', 'file_name',
                              'Owner', 'cnag_barcode', 'file_type', 'library_layout', 'ExomeKit',
                              'read_length', 'instrument_model', 'SequencingCenter'];

const header_files_config = [
    { label: "File Name" , key: "file_name" },
    { label:  config.platform_label + ' ID', key: 'ExperimentID', tooltip: "Unique " + config.platform_label + " Experiment Identifier."},
    { label: "Owner" , key: "Owner" },
    { label: "Local Experiment ID" , key: "LocalExperimentID" },
    { label: "Participant ID" , key: "Participant_ID" },
    { label: 'CNAG Barcode', key: 'cnag_barcode', tooltip: "Lims barcode associated to the experiment for samples sequenced at the CNAG"},
    { label: "File Type" , key: "file_type" },
    { label: "Sequencing Strategy" , key: "library_layout" },
    { label: "Protocol/Kit" , key: "ExomeKit" },
    { label: "Read Length" , key: "read_length" },
    { label: "Intrument Model" , key: "instrument_model" },
    { label: "Sequencing Center" , key: "SequencingCenter" },
    { label: "Submission Date" , key: "SubmitDate" }
]

const aggr_keys_qc_metrics = [ 'genome_ref', 'kit'];

const qc_metrics_search_delayed = ['sample', 'ROI_Size', 'mean_cov', 'media_cov', 'c10', 
                                   'c15', 'c20', 'c30', 'sex_ratio', 'sex'];

const header_qc_metrics_config = [
    { label: 'Experiment', key: 'sample', tooltip: "Sample unique " + config.platform_label + " Identifier."},
    { label: "Mean" , key: "mean_cov", tooltip: "Mean Coverage" },
    { label: "Median" , key: "median_cov", tooltip: "Median Coverage" },
    { label: "c10" , key: "c10", tooltip: "Proportion of ROI covered by at least 10 reads."},
    { label: "c15" , key: "c15", tooltip: "Proportion of ROI covered by at least 15 reads."},
    { label: "c20" , key: "c20", tooltip: "Proportion of ROI covered by at least 20 reads."},
    { label: "c30" , key: "c30", tooltip: "Proportion of ROI covered by at least 30 reads."},
    { label: "Y_ratio" , key: "sex_ratio", tooltip: "Ratio of reads mapping to ChrY/Autosomes" },
    { label: "Sex", key: "sex", tooltip: "WXS: (F is Y_ratio < 0.20 otherwise M) WGS: (F is Y_ratio < 0.05 otherwise M)"},
    { label: 'Reference', key: 'genome_ref', tooltip: "Genomic Reference used for alignment."},
    { label: 'Protocol/Kit', key: 'kit', tooltip: "Exome enrichment kit, or WGS."},
    { label: "ROI" , key: "ROI_Size", tooltip: "Size of the target Region Of Interest." }
]

export {aggr_keys, header_exp_config, header_files_config, exp_search_delayed, 
    files_search_delayed, header_qc_metrics_config, qc_metrics_search_delayed,
    aggr_keys_qc_metrics}
